// ShellModalRoot — the dialog host's five-layer stack (@symbo.ls/windows
// ModalRoot): a layer shows only while its slot of the stack holds a dialog —
// hidden, invisible and click-through otherwise. One definition for every
// root that hosts dialogs: the workspace shell (app.js `ModalRoot`) and the
// comm app (comm/app.js). Each root keeps its own mount props (zIndex,
// pointer-events, its mount latch).
export const ShellModalRoot = {
  extends: 'ModalRoot',
  // The windows base reads `el.layer` for visibility. On a cold DOMQL
  // construction that property can still be the reactive factory itself,
  // which is truthy before its return value has been installed. The result
  // is a visible, content-less ModalWindow on every page refresh. Read the
  // owning ModalRoot state directly in each preallocated slot; this is also
  // the subscription source the windows package documents for v3.14.
  ModalLayer_0: {
    display: (el, s) => (s?.stack?.[0] ? 'flex' : 'none'),
    opacity: (el, s) => (s?.stack?.[0] ? '1' : '0'),
    visibility: (el, s) => (s?.stack?.[0] ? 'visible' : 'hidden'),
    pointerEvents: (el, s) => (s?.stack?.[0] ? 'auto' : 'none')
  },
  ModalLayer_1: {
    display: (el, s) => (s?.stack?.[1] ? 'flex' : 'none'),
    opacity: (el, s) => (s?.stack?.[1] ? '1' : '0'),
    visibility: (el, s) => (s?.stack?.[1] ? 'visible' : 'hidden'),
    pointerEvents: (el, s) => (s?.stack?.[1] ? 'auto' : 'none')
  },
  ModalLayer_2: {
    display: (el, s) => (s?.stack?.[2] ? 'flex' : 'none'),
    opacity: (el, s) => (s?.stack?.[2] ? '1' : '0'),
    visibility: (el, s) => (s?.stack?.[2] ? 'visible' : 'hidden'),
    pointerEvents: (el, s) => (s?.stack?.[2] ? 'auto' : 'none')
  },
  ModalLayer_3: {
    display: (el, s) => (s?.stack?.[3] ? 'flex' : 'none'),
    opacity: (el, s) => (s?.stack?.[3] ? '1' : '0'),
    visibility: (el, s) => (s?.stack?.[3] ? 'visible' : 'hidden'),
    pointerEvents: (el, s) => (s?.stack?.[3] ? 'auto' : 'none')
  },
  ModalLayer_4: {
    display: (el, s) => (s?.stack?.[4] ? 'flex' : 'none'),
    opacity: (el, s) => (s?.stack?.[4] ? '1' : '0'),
    visibility: (el, s) => (s?.stack?.[4] ? 'visible' : 'hidden'),
    pointerEvents: (el, s) => (s?.stack?.[4] ? 'auto' : 'none')
  }
}
